"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COOKIE_USER_FEEDBACK_LAST_SUBMITTED_QUESTION_INDEX = exports.COOKIE_USER_FEEDBACK_DISMISSED_DATE = exports.COOKIE_USER_FEEDBACK_SUBMITTED_DATE = void 0;
/** Date on which user submitted user feedback */
exports.COOKIE_USER_FEEDBACK_SUBMITTED_DATE = "user-feedback-submitted-date";
/** Date on which user dismissed user feedback */
exports.COOKIE_USER_FEEDBACK_DISMISSED_DATE = "user-feedback-dismissed-date";
/** Index of last submitted user feedback question, in case user dismisses survey halfway through */
exports.COOKIE_USER_FEEDBACK_LAST_SUBMITTED_QUESTION_INDEX = "user-feedback-last-submitted-question-index";
//# sourceMappingURL=cookies.js.map